import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const AddBasicUser = () => {
  const [cities, setCities] = useState([]);

  const initialFormData = {
    email: "",
    fullName: "",
    password: "",
    city: "",
    companyName: "",
    address: "",
    mobileNo: "",
    workExpYear: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const navigate = useNavigate();

  const userCity = localStorage.getItem("city");

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
          setFormData({ ...formData, city: userCity });
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();

    let name = e.target.name;
    let value = e.target.value;

    if (name === "mobileNo") {
      value = value.replace(/\D/g, ""); // Keep only digits
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("data", formData);

    if (formData?.mobileNo?.length !== 10) {
      toast.error("Mobile number should be in 10 digits");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      const res = await HomeService.addBasicUser(formData);
      if (res?.status) {
        toast.success("Basic User added successfully!");
        setFormData(initialFormData);
        navigate("/manage-basic-user");
      } else {
        toast.error(res?.message || "Failed to add Basic User.");
      }
    } catch (error) {
      toast.error("Failed to add Basic User.");
      console.error("Error adding Basic User:", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Add Basic User
          </h2>

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div
                  className="col-md-6 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                >
                  <label>
                    Full Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="fullName"
                    value={formData?.fullName}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Full Name"
                    required
                  />
                </div>

                <div
                  className="col-md-6 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                >
                  <label>
                    Mobile Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobileNo"
                    value={formData?.mobileNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Mobile Number"
                    maxLength={10}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Email Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData?.email || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Email address"
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label>
                    Password<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="password"
                    value={formData?.password || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Password"
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={formData?.city || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData?.address || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter address"
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="companyName"
                    value={formData?.companyName || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Company Name"
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>Work Experience</label>
                  <input
                    type="text"
                    className="form-control"
                    name="workExpYear"
                    value={formData?.workExpYear || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Work Experience"
                  />
                </div>
              </div>
              <button
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                }}
                type="submit"
                className="btn mt-3"
              >
                Submit
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AddBasicUser;
